// src/hooks/usePerm.js
import { useState, useEffect } from "react";

export function usePerm() {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const handler = () => setVersion(v => v + 1);
    window.addEventListener("permissions-updated", handler);
    return () => window.removeEventListener("permissions-updated", handler);
  }, []);

  const hasPerm = (slug) => {
    const perms = JSON.parse(localStorage.getItem("perms") || "[]");
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user.role_id === "1" || perms.includes(slug);
  };

  return { hasPerm, version };
}